module.exports = __webpack_public_path__ + "static/media/Czech Republic.9287f60d.png";